import { v4 as uuid } from "uuid";
import { DashboardMenuProps } from "types";

export const DashboardMenu: DashboardMenuProps[] = [
  { id: uuid(), title: "Home", icon: "home", link: "/" },
  { id: uuid(), title: "Dashboard", icon: "clipboard", children: [] },
  { id: uuid(), title: "ADMIN", grouptitle: true, role: ["owner", "admin"]},
  { id: uuid(), title: "Users", icon: "user", link: "/admin/users" , role: ["owner", "admin"]},
  { id: uuid(), title: "Clients", icon: "users", link: "/admin/clients", role: ["owner", "admin"]},
  { id: uuid(), title: "Devices", icon: "hard-drive", link: "/admin/devices", role:  ["owner", "admin"]},
];

